import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../../baseComponents/TwinIcon'
import TwinTrans from '../../../baseComponents/TwinTrans'
import { Link } from 'react-router-dom'
import { ButtonPrimary } from '../../../baseComponents/Button'
import { getBasePath } from '../../../utils/globals/link'
import { useLocation } from 'react-router'
import { useMemo } from 'react'
import TwinToolTip from '../../../baseComponents/TwinToolTip'
import { RowData } from '../../../baseComponents/TwinTable/types'
import { getConfigParam } from '../../../utils/reducers/getters'
import { CodeCustomerToShowTyInversed } from '@teinor/erp/types/company/config/parameter'
import { CustomRenderString } from '../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
interface NoProjectsMessageProps {
    id: number
}

export const NoProjectsMessage: React.FC<NoProjectsMessageProps> = ({ id }) => {
    const location = useLocation()
    const basePathToProjects = getBasePath(location.pathname, String(id))
    return (
        <div className='flex items-center justify-center flex-col flex-auto'>
            <div className='regular22 text-red-BA'>
                <TwinIcon icon={faExclamationTriangle} className='mr-10 h-25' />
                <TwinTrans transKey='noProjectsInThisCustomer'>No dispone de proyectos en este cliente</TwinTrans>
            </div>
            <div className='my-25'>
                <span className='regular18'><TwinTrans transKey='mustCreateProjectsToSeeSection'>Debe crear proyectos para poder ver esta sección</TwinTrans></span>
            </div>
            <Link to={basePathToProjects + '/projects'}>
                <ButtonPrimary>
                    <TwinTrans transKey='createProjects'>Crear Proyectos</TwinTrans>
                </ButtonPrimary>
            </Link>
        </div>
    )
}

interface CustomerProjectRenderImageTooltipProps {
    id: number
    name?: string
    img: string
    tooltipName?: string
    className?: string
}

export const CustomerProjectRenderImageTooltip: React.FC<CustomerProjectRenderImageTooltipProps> = ({ id, name, img, tooltipName, className }) => {
    const myName = name
    const idTooltip = useMemo(() => 'Tooltip_CustomRenderImage' + tooltipName + '' + String(id), [id, tooltipName])
    return (
        <div className={'twin_elipsis ' + (className || '')}>
            {myName ?
                <TwinToolTip id={idTooltip} place='top' className='max-w-600'>
                    <p className='text-wrap-initial'>{myName}</p>
                </TwinToolTip>
            : null}
            <img data-tooltip-id={idTooltip} src={img} alt={name} className='w-27 object-cover min-w-27 h-27 rounded-full' />
        </div>
    )
}

interface CustomCustomerRenderWithLabelProps {
    className?: string
    label: string
    allRowData: RowData
}

export const CustomCustomerRenderWithLabel: React.FC<CustomCustomerRenderWithLabelProps> = ({ className, label, allRowData }) => {
    return (
        <div className={'flex flex-col ' + (className || '')}>
            <span className='light12 text-gray-51 mb-4'>{label}</span>
            <span className='regular14 overflow-hidden' ><CustomRenderCustomer allRowData={allRowData} /></span>
        </div>
    )
}


interface CustomRenderCustomerProps {
    allRowData: RowData
}

export const CustomRenderCustomer: React.FC<CustomRenderCustomerProps> = ({ allRowData }) => {
    if (!allRowData?.Customer) {
        return <div>--</div>
    }
    const codeCustomerToShow = getConfigParam('codeCustomerToShow')
    let fieldId: 'id' | 'code' = 'id'
    if (parseInt(String(codeCustomerToShow)) === parseInt(String(CodeCustomerToShowTyInversed['codeCustomer']))) {
        fieldId = 'code'
    }
    const code = allRowData?.Customer?.[fieldId]
    const value = (code ? (code + ' - ') : '') + allRowData?.Customer?.name
    return (
        <CustomRenderString value={value} />
    )
}